export function useAuth() {
  // Simple dev-friendly hook: always allow permissions and expose a mock current user.
  // In production this should be replaced with real session/auth state.
  return {
    hasPermission: (_module: string, _action: string) => true,
    user: {
      id: 'u_dev',
      name: 'Dev User',
      email: 'dev@local',
    },
  } as const;
}

export default useAuth;
